import t from "../locales";
import inti from "../assets/images/inti.png";
import { useEffect } from "react";
import treeLogo from "../assets/images/tree_logo_color.svg";

export default function Einde() {
  useEffect(() => {
    // Notify frame that user is done
    window.top.postMessage({ type: "showButtons" }, "*");
  }, []);

  return (
    <div className="screen-generic">
      <div className="screen-generic__top-image-container">
        <span className="screen-generic__top-image-copyright">
          © Lies Willaert
        </span>
        <img src={inti} alt="inti" className="screen-generic__top-image" />
      </div>
      <div className="screen-generic__content">
        <div className="screen-generic__paragraphs">
          <p className="screen-generic__text screen-generic__text--light">
            {t("screens_outro_you_hacked_pt_1")}
          </p>
          <p className="screen-generic__text screen-generic__text--light">
            {t("screens_outro_you_hacked_pt_2")}
          </p>
          <p className="screen-generic__text screen-generic__text--light">
            {t("screens_outro_you_hacked_pt_3")}
          </p>
        </div>
        <div className="screen-generic__tile">
          <p className="screen-generic__tile-why">
            {t("screens_outro_why_bad")}
          </p>
          <p className="screen-generic__tile-text">
            {t("screens_outro_someone_can")}
          </p>
          <ul className="screen-generic__list">
            <li className="screen-generic__list-item">
              {t("screens_outro_someone_can_bullet_1")}
            </li>
            <li className="screen-generic__list-item">
              {t("screens_outro_someone_can_bullet_2")}
            </li>
            <li className="screen-generic__list-item">
              {t("screens_outro_someone_can_bullet_3")}
            </li>
            <li className="screen-generic__list-item">
              {t("screens_outro_someone_can_bullet_4")}
            </li>
            <li className="screen-generic__list-item">
              {t("screens_outro_someone_can_bullet_5")}
            </li>
            <li className="screen-generic__list-item">
              {t("screens_outro_someone_can_bullet_6")}
            </li>
          </ul>
          <p className="screen-generic__tile-why">
            {t("screens_outro_important_conclusion")}
          </p>
        </div>
      </div>
      <div className="screen-generic__footer">
        <img
          src={treeLogo}
          alt={t("logo_tree")}
          className="screen-generic__logo"
        />
      </div>
    </div>
  );
}
